import { useReducer } from 'react'
import { AuthContext } from './context'
import { authReducer, initialAuthState } from './reducers'

export default function AuthStateProvider({ children }) {
	const [state, dispatch] = useReducer(authReducer, initialAuthState)

	return (
		<AuthContext.Provider value={[state, dispatch]}>
			{children}
		</AuthContext.Provider>
	)
}
